<template>
  <div>
    <div v-if="fullIPTVData.iptv_service_data">
      <b-tabs pills card>
        <b-tab :title="$t('Main')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-input type="text" disabled v-model="selectAccountingPeriod" aria-describedby="inputFeedback" :state="selectAccountingPeriod.length > 0" :placeholder="$t('Tap to select')"/>
                <div style="position:absolute; left:0; right:0; top:0; bottom:0;" @click="showFormAccountingPeriod" v-if="!isEdit && !accountingPeriodId"/>
                <b-form-invalid-feedback id="inputFeedback">
                  {{ $t('Select accounting period') }}
                </b-form-invalid-feedback>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charge policy')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-input-group>
                <b-form-select :options="listOfChargePolicy" v-model="IPTVservice.policy_id"/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormChargePolicies">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Scheme for schedule')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select  :disabled="isEdit && IPTVservice.scheme_id > 0" :options="listOfCoefficientScheme" v-model="IPTVservice.scheme_id" @change="coeffSchemeChanged"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Cost %')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :disabled="IPTVservice.scheme_id > 0" type="number" v-model="IPTVservice.cost_coef"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Charged')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="isEdit">
              <b-input-group>
                <b-form-input type="text" v-model="IPTVservice.charged_in_curr_period" disabled/>
                <b-input-group-append>
                  <b-button variant="info" size="sm" @click="showFormCharged">{{ $t('Details') }}</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-tab>
        <b-tab :title="$t('Additional')">
          <b-col>
            <b-form-group label-align="right" :label="$t('Start date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderStartDate"
              :isDisabled="isEdit"
              @onDateChanged="(unixDate) => {IPTVservice.start_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(IPTVservice.start_date ? IPTVservice.start_date : new Date()/1000 ).toDate())}"
              />
            </b-form-group>
            <b-form-group label-align="right" :label="$t('End date')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <flat-picker :key="rerenderExpireDate"
              :isDisabled="infinityDate"
              @onDateChanged="(unixDate) => {IPTVservice.expire_date = unixDate}"
              @ready="(dp) => {dp.setDate($root.getMomentWithTZDelta(IPTVservice.expire_date ? IPTVservice.expire_date : new Date()/1000 ).toDate())}"
              />
              <b-form-checkbox v-model="infinityDate">{{ $t('Infinity date') }}</b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Comment')" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="![0,6].includes(fullIPTVData.iptv_service_data.type)">
              <b-form-input type="text" v-model="IPTVservice.comment"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('IPTV access card')" :disabled="isEdit" label-cols="4" label-cols-xl="4" label-cols-md="4" v-if="fullIPTVData.iptv_service_data.type == 0">
              <b-form-select :options="accessCards" v-model="IPTVservice.comment"/>
            </b-form-group>
          </b-col>
        </b-tab>
      </b-tabs>
    </div>

    <modal-ok-cancel @save="saveServiceLink" @cancel="hideSelectService"/>

    <b-modal ref="accoutingPeriod" hide-footer :title="$t('Accounting period')" size="xl">
      <FormAccountinfPeriod
        v-model="IPTVservice.accounting_period_id"
        @hideAccoutingPeriod="hideAccoutingPeriod"/>
    </b-modal>

    <b-modal ref="detailChargePolicies" hide-footer size="lg">
      <FormChargePolicies v-if="currentChargePolicy" @hideFormChargePolicies="hideFormChargePolicies" :currentChargePolicy="currentChargePolicy"/>
    </b-modal>

    <b-modal ref="detailCharge" hide-footer :title="$t('Periodic service statisticsperiod')">
      <FormCharged @hideFormCharged="hideFormCharged" :currentService="currentService"/>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import FormAccountinfPeriod from './formAccountingPeriod'
import FormChargePolicies from '@/pages/tariffication/additional/chargePolicies/editModal.vue'
import FormCharged from './formCharged'
export default {
  components: {
    FormAccountinfPeriod,
    FormChargePolicies,
    FormCharged
  },
  props: {
    listOfCoefficientScheme: null,
    listOfChargePolicy: null,
    tariffLinkId: 0,
    accountingPeriodId: 0,
    currentUser: null,
    currentService: null,
    selectedAccount: null,
    isEdit: null
  },
  data () {
    return {
      currentChargePolicy: null,
      infinityDate: true,
      IPTVserviceEdit: [],
      IPTVservice: {
        'user_id': 0,
        'account_id': 0,
        'service_id': 0,
        'tariff_link_id': 0,
        'accounting_period_id': 0,
        'start_date': moment().unix(),
        'expire_date': moment(2000000000 * 1000).unix(),
        'policy_id': 1,
        'scheme_id': 0,
        'cost_coef': 100,
        'comment': '',
        'charged_in_curr_period': 0
      }
    }
  },
  methods: {
    coeffSchemeChanged (schemeId) {
      if (schemeId === 0) {
        this.IPTVservice.cost_coef = 100
      } else {
        let newCostCoef = 100
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === schemeId) {
            for (let elIt of el.items) {
              if (elIt.delay === 0) {
                newCostCoef = elIt.coeff * 100
                break
              }
            }
            break
          }
        }
        this.IPTVservice.cost_coef = newCostCoef
      }
    },
    addCoefSchemeToSlink (newSlinkId) {
      if ((!this.isEdit && this.IPTVservice.scheme_id > 0) ||
     (this.IPTVserviceEdit !== null &&
     this.IPTVserviceEdit.coefficientschedulelink === undefined &&
     this.IPTVservice.scheme_id > 0)) {
        let coefSchedule = {items: []}
        for (let el of this.$store.getters['Tariffing/COEFFICIENT_SCHEME']) {
          if (el.id === this.IPTVservice.scheme_id) {
            coefSchedule.items = el.items
          }
        }
        let responseCoefScheduleId = this.$store.dispatch('Users/CREATE_COEFFICIENT_SCHEDLE', coefSchedule)
        responseCoefScheduleId.then(responseCoefScheduleId => {
          let newCoefScheduleId = responseCoefScheduleId.data.coefficient_schedule_id
          let schedule = {
            scheme_id: this.IPTVservice.scheme_id,
            slink_id: Number(newSlinkId),
            schedule_id: Number(newCoefScheduleId),
            change_policy: 0
          }
          this.$store.dispatch('Users/CREATE_UERS_SERVICELINKS_COEFFICIENT_SCHEDLE', schedule)
        })
      }
    },
    hideSelectService () {
      this.$emit('hideSelectService')
    },
    showFormCharged () {
      this.$refs.detailCharge.show()
    },
    hideFormCharged () {
      this.$refs.detailCharge.hide()
    },
    showFormAccountingPeriod () {
      this.$refs.accoutingPeriod.show()
    },
    hideAccoutingPeriod () {
      this.$refs.accoutingPeriod.hide()
    },
    showFormChargePolicies () {
      for (let el of this.$store.getters['Tariffing/CHARGE_POLICIES']) {
        if (this.IPTVservice.policy_id === el.policy_id) {
          this.currentChargePolicy = JSON.parse(JSON.stringify(el))
          this.$refs.detailChargePolicies.show()
        }
      }
    },
    hideFormChargePolicies () {
      this.$refs.detailChargePolicies.hide()
    },
    saveServiceLink () {
      if (!this.IPTVservice.accounting_period_id) {
        this.$root.$emit('makeToasts', 'danger', this.$i18n.t('Select accounting period'), 'Error')
        return
      }
      let tmpIPTVservice = JSON.parse(JSON.stringify(this.IPTVservice))
      tmpIPTVservice.cost_coef = tmpIPTVservice.cost_coef / 100
      tmpIPTVservice.expire_date = this.infinityDate ? 2000000000 : tmpIPTVservice.expire_date
      tmpIPTVservice.tplink_id = this.tariffLinkId ? this.tariffLinkId : 0
      tmpIPTVservice.comment = String(tmpIPTVservice.comment)
      if (this.isEdit) {
        tmpIPTVservice.slink_id = this.currentService.service_link_id
      } else {
        tmpIPTVservice.account_id = this.selectedAccount
        tmpIPTVservice.service_id = this.currentService.service_id
        tmpIPTVservice.user_id = this.currentUser.user_id
      }
      let response = this.isEdit
        ? this.$store.dispatch('Users/UPDATE_IPTV_SERVICE_LINK', tmpIPTVservice)
        : this.$store.dispatch('Users/CREATE_IPTV_SERVICE_LINK', tmpIPTVservice)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          let newSlinkId = response.data.service_link_id ? response.data.service_link_id : this.currentService.service_link_id
          this.addCoefSchemeToSlink(newSlinkId)
          this.$store.dispatch('Users/GET_USER_SERVICES_LINKS_ACC', this.selectedAccount)
          this.hideSelectService()
          this.$root.$emit('makeToasts')
        }
      })
    }
  },
  computed: {
    selectAccountingPeriod () {
      let selectAccountingPeriod = ''
      if (this.IPTVservice.accounting_period_id > 0) {
        for (let el of JSON.parse(JSON.stringify(this.$store.getters['Tariffing/ACCOUNTING_PERIODS']))) {
          if (el.id === this.IPTVservice.accounting_period_id) {
            el.begin = this.$root.getMomentWithTZDelta(Number(el.begin)).format('MM-DD-YYYY')
            el.end = this.$root.getMomentWithTZDelta(Number(el.end)).format('MM-DD-YYYY')
            selectAccountingPeriod = el.begin + ' / ' + el.end + ' (' + el.id + ')'
          }
        }
      }
      return selectAccountingPeriod
    },
    accessCards () {
      let tmp = this.$store.getters['Users/ACCESS_CARDS']
      for (let el of tmp) {
        el.text = el.username + '(' + el.card_number + ')'
        el.value = el.card_number
      }
      return tmp
    },
    fullIPTVData () {
      return this.$store.getters['Tariffing/IPTV_SERVICE']
    }
  },
  mounted () {
    this.IPTVservice.scheme_id = this.currentService.scheme_id
    this.coeffSchemeChanged(this.currentService.scheme_id)
    if (this.isEdit) {
      this.$store.dispatch('Users/GET_IPTV_SERVICE_LINK', this.currentService.service_link_id).then(response => {
        this.IPTVserviceEdit = this.$store.getters['Users/IPTV_SERVICE_LINK']
        this.IPTVservice.start_date = this.IPTVserviceEdit.periodicservicelink.start_date
        this.IPTVservice.expire_date = this.IPTVserviceEdit.periodicservicelink.expire_date
        this.rerenderStartDate += 1
        this.rerenderExpireDate += 1
        this.infinityDate = this.IPTVserviceEdit.periodicservicelink.expire_date === 2000000000
        this.IPTVservice.cost_coef = this.IPTVserviceEdit.periodicservicelink.cost_coef * 100
        this.IPTVservice.comment = this.IPTVserviceEdit.periodicservicelink.comment
        this.IPTVservice.accounting_period_id = this.IPTVserviceEdit.periodicservicelink.accounting_period_id
        this.IPTVservice.policy_id = this.IPTVserviceEdit.periodicservicelink.policy_id
        this.IPTVservice.scheme_id = this.IPTVserviceEdit.coefficientschedulelink.scheme_id
        this.IPTVservice.charged_in_curr_period = Number.parseFloat(this.IPTVserviceEdit.periodicservicelink.charged_in_curr_period).toFixed(3)
      })
    } else {
      this.IPTVservice.policy_id = this.currentService.policy_id
      this.IPTVservice.accounting_period_id = this.accountingPeriodId ? this.accountingPeriodId : 0
    }
    this.$store.dispatch('Tariffing/GET_IPTV_SERVICE', this.currentService.service_id)
    this.$store.dispatch('Users/GET_ACCESS_CARDS', this.currentUser.user_id)
    if (this.currentService.addByDefault) {
      this.saveServiceLink()
    }
    this.coeffSchemeChanged()
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/usersAndGroups/detail/serviceLinks/formIPTV.vue